<template>
  <ReportWrapper
    :disable-download="!selectedDateRange"
    :is-downloading="isLoading"
    @download="downloadPdf"
  >
    <template #prepend>
      <CfsDateField v-model="selectedDateRange" placeholder="Date" range />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import { useToast } from '@/composables/useToast';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'IpiActivityReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const toast = useToast();

    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const downloadPdf = async () => {
      if (!selectedDateRange.value) return toast.info('Please select date.');

      try {
        const { data } = await downloadReport({
          fromdate: selectedDateRange.value?.start,
          todate: selectedDateRange.value?.end,
          documentType: DocumentTypes.IPI_ACTIVITY,
          outputType: OutputTypes.XLSX,
        });

        if (!data) return;

        downloadFileByType(
          data,
          `IPI Activity Report ${date(selectedDateRange.value?.start)} - ${date(
            selectedDateRange.value?.end
          )}`,
          OutputTypes.XLSX
        );
      } catch (e) {
        console.log(e);
      }
    };

    return { selectedDateRange, isLoading, downloadPdf };
  },
});
</script>
